import { useState, useEffect } from "react"
import { useLazyQuery } from "@apollo/client"
import _ from "lodash"

const useQueryVariables = ({ columnDefs, optionsQuery }) => {
  const [defs, setDefs] = useState(
    columnDefs?.map((column) => {
      return column?.defaultValue
        ? { ...column, value: column.defaultValue }
        : { ...column, value: null }
    })
  )

  const [gqlVariables, setGqlVariables] = useState({})

  const [
    queryOptionsData,
    { data: optionsData, error: optionsError }
  ] = useLazyQuery(optionsQuery?.[0], {
    ...optionsQuery?.[1]
  })

  useInitialData(queryOptionsData, optionsQuery)
  useConvertedGqlVariables(defs, setGqlVariables)

  const setValue = (name, value) => {
    const arr = defs

    _.set(_.find(arr, { name }), "value", value)
    setDefs(arr)
    convertGqlVariables(defs)
  }

  const convertGqlVariables = () => {
    setGqlVariables(
      Object.assign(
        {},
        ...defs.map((v) => ({ [v.name]: v.value || undefined }))
      )
    )
  }

  const onClear = () => {
    setDefs(defs.map((v) => ({ ...v, value: v?.defaultValue })))
    convertGqlVariables()
  }

  return {
    columnDefs: defs,
    setValue,
    variables: gqlVariables,
    onClear,
    error: optionsError,
    options: optionsData
  }
}

const useInitialData = (queryOptionsData, optionsQuery) => {
  useEffect(() => {
    executeFetch()

    async function executeFetch() {
      if (optionsQuery) {
        await queryOptionsData()
      }
    }

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

const useConvertedGqlVariables = (defs, setGqlVariables) => {
  useEffect(() => {
    if (!defs || defs?.length === 0) {
      return () => {}
    }

    setGqlVariables(
      Object.assign(
        {},
        ...defs.map((v) => ({ [v.name]: v.value || undefined }))
      )
    )

    return () => {}
  }, [defs, setGqlVariables])
}

export default useQueryVariables
